var $9246f2c6edc6b232$exports = {};
$9246f2c6edc6b232$exports = {
  "buttonLabel": "\uC81C\uC548 \uC0AC\uD56D \uD45C\uC2DC",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), "\uAC1C \uC635\uC158");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), "\uAC1C \uC635\uC158");
      }
    }), "\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\uC785\uB825\uD55C \uADF8\uB8F9 ".concat(args.groupTitle, ", ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), "\uAC1C \uC635\uC158");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), "\uAC1C \uC635\uC158");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \uC120\uD0DD\uB428",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\uC81C\uC548",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \uC120\uD0DD\uB428");
  }
};
export { $9246f2c6edc6b232$exports as default };